import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectCurrentLanguage } from '../../features/langSlice';
import { useGetContentsByTagWebQuery } from '../../features/contentsApiSlice';
import EffectAccordion from './EffectAccordion';
import { selectSlug } from '../../features/contentsSlice';
import { useGetAssetsQuery } from '../../features/quizApiSlice';
import NoMorePillsVideo from '../../assets/riise-people-sport-energy-granules.mp4';
import productImg from '../../assets/yellow-paper-pouch-granules.webp';
import Whatsapp from '../../assets/here1.webp';

import {
  WhatAreYourWellnessGoals,
  CustomerReviews,
  FormulaHeading,
  HereMainHeading,
  PersonaliseMine,
  FreeShippingBanner,
  Energy,
  Focus,
  SportPerformance,
  Mood,
  Sleep,
  Stress,
  Digestion,
  ImmuneSystem,
  Skin,
  Hair,
  Nails,
  MusclePain,
  Eyes,
  BonesAndJoints,
  You,
  Heart,
  BannerHeading1,
  BannerHeading2,
  BannerText1,
  BannerText2,
  FormulatedByExperts,
  Faq,
  FaqMore,
  FaqPage,
  HomeTakeTestButton,
  TailoredToYouDesc,
  TailoredToYou,
  NoPills,
  HeroH1Lead,
  HeroH1Tail,
  HeroSubline,
  HeroSocialProof,
  HeroCtaShort,
  Review1,
  Review2,
  Review3,
  Review4,
  ReviewRating,
  BuiltByScience,
  CustomerReviewsDesc,
} from '../../Constants';
import { FOCUS_AREA_LINKS } from '../../utils';
import { findAssetByCodeOrName, getAssetDisplayName } from '../../utils/assets';
import ReviewsOverlay from '../Reviews';
import PersonalFormulasSection from './PersonalFormulasSection';
import { Helmet } from 'react-helmet';
import Made from './Made';
import Unique from './Unique';
import HighStandards from './HighStandards';
import MillionCombinations from './MillionCombinations';
import MakeChoice from './MakeChoice';
import Partners from './Partners';
import HereForYou from '../Customer/components/HereForYou';
import CustomLink from '../CustomLink';
import SmartFormulas from './SmartFormulas';
import useMeta from '../../hooks/useMeta';
import UniqueWeb from '../FocusAreas/components/UniqueWeb';
import CountdownTimer from '../CountdownTimer';
import ExpertSection from '../Customer/components/ExpertSection';
import ResultYouFeel from '../Customer/components/ResultYouFeel';
import ReviewsMobile from '../Customer/components/ReviewsMobile';
import IngredientsSlider from './Slider/IngredientsSlider';
import VeganComponent from './Vegan';
import BoomTestimonials from '../Customer/components/BoomTestimonials';
import { normalizeLanguageCode, formatAbbreviatedNumber } from '../../utils/language';

const heroMobileImg = `${process.env.PUBLIC_URL}/hero-mobile.webp`;
const heroDesktopImg = `${process.env.PUBLIC_URL}/hero-desktop.webp`;

function useCountUp(target, duration = 1500) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    let start = null;
    const step = (ts) => {
      if (!start) start = ts;
      const progress = Math.min((ts - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(Math.floor(eased * target));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [target, duration]);
  return count;
}

const Home = () => {
  const selectedLang = useSelector(selectCurrentLanguage);
  const { t } = useTranslation();
  const dosesCount = useCountUp(300000, 1800);
  const formattedDoses = formatAbbreviatedNumber(dosesCount, selectedLang);
  const [lang, setLang] = useState();
  const slug = useSelector(selectSlug);
  const quiz_id = localStorage.getItem('quiz_id');

  const [picture7, setPicture7] = useState('');
  const [picture8, setPicture8] = useState('');
  const [picture13, setPicture13] = useState('');
  const [picture14, setPicture14] = useState('');
  const [picture15, setPicture15] = useState('');
  const [expertsData] = useState([]);

  const [data, setData] = useState([]);
  const [skip] = useState(false);

  const {
    data: fetchContents,
    isSuccess,
    refetch,
  } = useGetContentsByTagWebQuery({ tag: 'home', lang: lang, skip: skip });

  useEffect(() => {
    setLang(normalizeLanguageCode(selectedLang));

    refetch();
  }, [refetch, lang, selectedLang]);

  useEffect(() => {
    if (isSuccess) {
      setData(fetchContents.data);
      if (fetchContents.data.length > 0) {
        let pics = [];
        setPicture7(`${process.env.REACT_APP_PUBLIC_URL}${fetchContents.data[6].picture}`);
        setPicture8(`${process.env.REACT_APP_PUBLIC_URL}${fetchContents.data[7].picture}`);
        pics.push(`${process.env.REACT_APP_PUBLIC_URL}${fetchContents.data[4].picture}`);
        pics.push(`${process.env.REACT_APP_PUBLIC_URL}${fetchContents.data[6].picture}`);
        pics.push(`${process.env.REACT_APP_PUBLIC_URL}${fetchContents.data[7].picture}`);

        expertsData.push({ data: fetchContents.data[6], picture: pics[1] });
        expertsData.push({ data: fetchContents.data[7], picture: pics[2] });

        setPicture13(`${process.env.REACT_APP_PUBLIC_URL}${fetchContents.data[12].picture}`);
        setPicture14(`${process.env.REACT_APP_PUBLIC_URL}${fetchContents.data[13].picture}`);
        setPicture15(`${process.env.REACT_APP_PUBLIC_URL}${fetchContents.data[14].picture}`);
      }
    }
  }, [fetchContents]);

  const [reviewData, setReviewData] = useState();
  useEffect(() => {
    const observer = new MutationObserver(() => {
      const reviewsCount = document.querySelectorAll('.cssVar-subheading__number');
      if (reviewsCount) {
        const reviews = [];
        reviewsCount.forEach((element) => {
          reviews.push(element.innerHTML);
        });
        setReviewData(reviews);
      }
    });

    // Start observing the target node for DOM changes
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Clean up the observer when the component unmounts
    return () => observer.disconnect();
  }, []);

  const [scrolledPastHero, setScrolledPastHero] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolledPastHero(window.scrollY > 500);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const sectionRef = useRef(null);
  const scrollToSectionEnd = () => {
    if (sectionRef.current) {
      const headerHeight = document.querySelector('header')?.offsetHeight || 0;
      const top = sectionRef.current.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  const { data: news } = useGetAssetsQuery({ section: 'homepageNews', lang });
  const { data: focusAreaIcons } = useGetAssetsQuery({ section: 'focusAreaIcon', lang });
  const { data: focusAreas } = useGetAssetsQuery({ section: 'homepageFocusArea', lang });

  const filteredFocusAreas = useMemo(
    () => focusAreas?.data || [],
    [focusAreas],
  );

  const [focusAreass, setFocusAreass] = useState([]);
  const [currentFocus, setCurrentFocus] = useState(null); // Initialize as null
  const [fadeClass, setFadeClass] = useState('fade-in');

  useEffect(() => {
    const updatedFocusAreass = [
      t(You),
      t(Energy),
      t(Focus),
      t(SportPerformance),
      t(Mood),
      t(Sleep),
      t(Stress),
      t(Digestion),
      t(ImmuneSystem),
      t(Skin),
      t(Hair),
      t(Nails),
      t(Heart),
      t(MusclePain),
      t(Eyes),
      t(BonesAndJoints),
    ];

    setFocusAreass(updatedFocusAreass);
    setCurrentFocus(updatedFocusAreass[0]);
  }, [t, selectedLang]);

  useEffect(() => {
    if (focusAreass.length === 0) return;

    let index = 0;
    const interval = setInterval(() => {
      setFadeClass('fade-out');
      setTimeout(() => {
        index = (index + 1) % focusAreass.length;
        setCurrentFocus(focusAreass[index]);
        setFadeClass('fade-in');
      }, 500);
    }, 2000);

    return () => clearInterval(interval);
  }, [focusAreass]);

  const { metaEvent } = useMeta();

  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="Discover personalized vitamins and supplements tailored to your unique needs with Riise. Take our 5-minute test to get started on your customized nutrition journey, backed by science."
        />
      </Helmet>
      <main className="!t-w-[100vw] t-max-w-[100vw]">
        <style>{`
          @keyframes heroPulse {
            0%, 100% { box-shadow: 0 0 0 0 rgba(246, 225, 71, 0.5); }
            50% { box-shadow: 0 0 0 8px rgba(246, 225, 71, 0); }
          }
          .hero-cta { animation: heroPulse 2s ease-in-out infinite; }
          .hero-cta:active { transform: scale(0.97); }
        `}</style>
        {/* Hero — single picture element, browser picks the right source */}
        <section className="md:t-hidden t-bg-surface">
          <img src={heroMobileImg} alt="riise personalised sachet" className="t-w-full t-h-auto t-block" />
          <div className="t-flex t-flex-col t-items-start t-gap-2 t-max-w-[420px] t-mx-auto t-px-5 t-pt-3 t-pb-4">
            <div
              className="t-flex t-items-center t-gap-2 t-text-navy t-font-sans t-text-sm t-cursor-pointer"
              onClick={scrollToSectionEnd}
            >
              <span className="t-text-butter t-text-base t-tracking-tight">★★★★★</span>
              <span className="t-font-semibold">
                {t(HeroSocialProof, { rating: reviewData?.[0]?.trim() || '4.89', doses: formattedDoses })}
              </span>
            </div>

            <h1 className="!t-m-0 t-text-navy t-font-serif t-font-normal t-text-[28px] t-leading-[1.05]">
              {t(HeroH1Lead)}
              <br />
              <em className="t-text-quiz-teal">{t(HeroH1Tail)}</em>
            </h1>

            <p className="!t-m-0 t-text-navy/80 t-font-sans t-text-[14px] t-leading-snug">{t(HeroSubline)}</p>

            <CustomLink
              to="/quiz"
              onClick={() => metaEvent('Lead')}
              className="t-w-full t-flex t-items-center t-justify-center t-mt-1"
            >
              <span className="hero-cta btn btn-custom-tertiary t-font-sans !t-rounded-lg !t-bg-primary !t-text-secondary t-w-full !t-max-w-[340px] !t-text-lg t-inline-flex t-items-center t-justify-center t-gap-2">
                {t(HeroCtaShort)}
                <span aria-hidden="true">→</span>
              </span>
            </CustomLink>
            <div className="t-w-full t-flex t-items-center t-justify-center">
              <Made />
            </div>
          </div>
        </section>

        {/* Desktop hero — text left, image right */}
        <section className="t-hidden md:t-block" style={{ backgroundColor: '#eeebe3' }}>
          <div className="t-max-w-[1400px] t-mx-auto t-grid t-grid-cols-2 t-gap-6 t-items-center t-px-8 lg:t-px-12 t-py-10 lg:t-py-14">
            <div className="t-flex t-flex-col t-items-start t-gap-5">
              <div
                className="t-flex t-items-center t-gap-2 t-text-navy t-font-sans t-text-base t-cursor-pointer"
                onClick={scrollToSectionEnd}
              >
                <span className="t-text-butter t-text-lg t-tracking-tight">★★★★★</span>
                <span className="t-font-semibold">
                  {t(HeroSocialProof, { rating: reviewData?.[0]?.trim() || '4.89', doses: formattedDoses })}
                </span>
              </div>
              <h1 className="!t-m-0 t-text-navy t-font-serif t-font-normal t-text-[56px] lg:t-text-[64px] t-leading-[1.05]">
                {t(HeroH1Lead)}
                <br />
                <em className="t-text-quiz-teal">{t(HeroH1Tail)}</em>
              </h1>
              <p className="!t-m-0 t-text-navy/80 t-font-sans t-text-lg t-max-w-[520px]">{t(HeroSubline)}</p>
              <CustomLink to="/quiz" onClick={() => metaEvent('Lead')} className="t-mt-2">
                <span className="hero-cta btn btn-custom-tertiary t-font-sans !t-rounded-lg !t-bg-primary !t-text-secondary !t-text-lg !t-px-8 t-inline-flex t-items-center t-gap-2">
                  {t(HeroCtaShort)}
                  <span aria-hidden="true">→</span>
                </span>
              </CustomLink>
              <Made />
            </div>
            <div className="t-flex t-justify-end t-items-center">
              <img
                src={heroDesktopImg}
                alt="riise personalised sachet"
                loading="lazy"
                className="t-w-full t-max-w-[760px] t-h-auto t-object-contain t-rounded-2xl"
              />
            </div>
          </div>
        </section>
        {/* <div className="t-flex md:t-hidden t-items-center t-justify-center t-p-2">
          <CountdownTimer isHomepage />
        </div> */}
        <section
          className="t-bg-navy t-py-2 t-overflow-hidden t-mb-8 md:t-mb-10 t-cursor-pointer"
          onClick={scrollToSectionEnd}
        >
          <style>{`@keyframes riiseMarquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }`}</style>
          <div
            className="t-flex t-whitespace-nowrap t-w-max"
            style={{ animation: 'riiseMarquee 45s linear infinite' }}
          >
            {[0, 1].map((dup) => (
              <div key={dup} className="t-flex t-items-center t-text-white t-font-sans t-text-sm">
                {[
                  t(Review1),
                  t(Review2),
                  t(Review3),
                  t(Review4),
                  <span key="rating" className="t-text-butter t-font-semibold">
                    {t(ReviewRating, { rating: reviewData?.[0]?.trim() || '4.9' })}
                  </span>,
                ].map((item, i) => (
                  <React.Fragment key={i}>
                    <span className="t-px-4">{item}</span>
                    <span className="t-text-butter">·</span>
                  </React.Fragment>
                ))}
              </div>
            ))}
          </div>
        </section>
        <div className="t-w-full t-max-w-[1320px] t-mx-auto t-flex t-flex-col t-gap-6 t-overflow-auto t-pb-6 md:t-pb-8">
          <BoomTestimonials />
          <CustomLink to="/quiz" className="t-flex t-items-center t-justify-center">
            <span className="btn btn-custom-secondary t-font-sans !t-bg-primary !t-text-secondary !t-w-[300px] !t-rounded-lg">
              {t(HomeTakeTestButton)}
            </span>
          </CustomLink>
        </div>

        <div className="t-max-w-[100vw] t-flex t-items-center t-justify-center">
          <Unique />
        </div>
        <div className="t-hidden md:t-block">
          <VeganComponent />
        </div>
        <div className="t-bg-navy t-py-4">
          <IngredientsSlider />
        </div>
        <div className="t-w-full t-max-w-[500px] lg:t-max-w-[900px] t-mx-auto t-py-6 md:t-py-8 t-px-4">
          <ResultYouFeel
            cta={(
              <CustomLink
                to="/quiz"
                onClick={() => metaEvent('Lead')}
                className="!t-w-[300px] lg:!t-w-full !t-mx-auto lg:!t-mx-0 t-flex t-items-center t-justify-center"
              >
                <span className="btn btn-custom-tertiary t-font-sans !t-rounded-lg !t-bg-primary hover:!t-text-white !t-text-secondary t-w-full !t-text-lg">
                  {t(HomeTakeTestButton)}
                </span>
              </CustomLink>
            )}
          />
        </div>
        <div className="t-w-full t-max-w-[700px] t-mx-auto t-flex t-flex-col t-gap-4 t-overflow-auto">
          <h2 className="!t-text-center t-px-4 t-font-serif t-font-normal t-text-navy">
            {t(BuiltByScience)}
          </h2>
          <ExpertSection lang={lang} />
          <HighStandards />
        </div>

        <section className="t-py-4">
          <div className="container t-flex t-flex-row t-items-center t-justify-center t-gap-2 md:t-gap-4 lg:t-gap-8">
            {news?.data?.map((item) => (
              <img
                src={`${process.env.REACT_APP_PUBLIC_URL}${item?.url}`}
                alt=""
                className="t-w-16 t-h-auto md:t-w-[5%]"
                key={'news-img-' + item.url}
              />
            ))}
          </div>
        </section>

        <section ref={sectionRef} className="t-pt-6 md:t-pt-8 t-bg-g100">
          <div className="container">
            <h2 className="t-text-[24px] md:t-text-[30px] !t-text-center t-font-serif t-font-normal t-text-navy">
              {t(CustomerReviews)}
            </h2>
            <p className="t-font-sans t-text-center !t-m-0 t-text-navy/70">{t(CustomerReviewsDesc)}</p>
            <ReviewsMobile />
          </div>
        </section>

        <section className="services t-pt-2 md:t-pt-8 t-pb-6 t-bg-white">
          <div className="container">
            <div className="row !t-mb-0">
              <div className="col-12">
                <div className="title-wrapper !t-pb-0 !t-mb-0">
                  <h3 className="t-text-[24px] md:t-text-[30px] t-text-center t-font-serif t-font-normal t-text-navy !t-mb-0 sm:!t-mb-2">
                    {data[1] && <span dangerouslySetInnerHTML={{ __html: data[1]?.title }} />}
                  </h3>
                </div>
              </div>
            </div>
            <div className="sm:t-hidden t-flex t-flex-row t-items-center t-gap-4 t-mt-0">
              <img src={productImg} alt="" className="!t-h-[80%] !t-w-[30%]" />
              <div className="t-flex t-flex-col t-justify-between t-gap-3 t-mt-2">
                {data[12] && (
                  <h5
                    className="t-text-[14px] !t-font-sans t-text-navy !t-font-normal"
                    dangerouslySetInnerHTML={{ __html: data[12]?.title }}
                  />
                )}
                {data[13] && (
                  <h5
                    className="t-text-[14px] !t-font-sans t-text-navy !t-font-normal"
                    dangerouslySetInnerHTML={{ __html: data[13]?.title }}
                  />
                )}
                {data[14] && (
                  <h5
                    className="t-text-[14px] !t-font-sans t-text-navy !t-font-normal"
                    dangerouslySetInnerHTML={{ __html: data[14]?.title }}
                  />
                )}
              </div>
            </div>
            <div className="!t-hidden sm:!t-flex row gy-2 t-items-start t-justify-center -t-mt-2">
              <div className="col-xl-3 col-md-6">
                <div className="services-item">
                  <img src={picture15} alt="" className="img-fluid d-none d-sm-block" />
                  <div className="services-meta">
                    {data[12] && (
                      <h4
                        className="px-0 t-w-full !t-font-sans !t-font-normal !t-text-[14px]"
                        dangerouslySetInnerHTML={{ __html: data[12]?.title }}
                      />
                    )}
                    {data[12] && (
                      <p className="!t-font-sans" dangerouslySetInnerHTML={{ __html: data[12]?.contents }} />
                    )}
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-md-6">
                <div className="services-item">
                  <img src={picture14} alt="" className="img-fluid d-none d-sm-block" />
                  <div className="services-meta">
                    {data[13] && (
                      <h4
                        className="px-0 t-w-full !t-font-sans !t-font-normal !t-text-[14px]"
                        dangerouslySetInnerHTML={{ __html: data[13]?.title }}
                      />
                    )}
                    {data[13] && (
                      <p className="!t-font-sans" dangerouslySetInnerHTML={{ __html: data[13]?.contents }} />
                    )}
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-md-6">
                <div className="services-item">
                  <img src={picture13} alt="" className="img-fluid d-none d-sm-block" />
                  <div className="services-meta">
                    {data[14] && (
                      <h4
                        className="px-0 t-w-full !t-font-sans !t-font-normal !t-text-[14px]"
                        dangerouslySetInnerHTML={{ __html: data[14]?.title }}
                      />
                    )}
                    {data[14] && (
                      <p className="!t-font-sans" dangerouslySetInnerHTML={{ __html: data[14]?.contents }} />
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="t-flex t-items-center t-justify-center t-mt-2 sm:t-mt-6">
              <div className="col-auto !t-mx-auto">
                <CustomLink to="/quiz">
                  <span className="btn btn-custom-secondary t-font-sans !t-bg-primary !t-text-secondary !t-w-[300px] !t-rounded-lg">
                    {t(HomeTakeTestButton)}
                  </span>
                </CustomLink>
              </div>
            </div>
          </div>
        </section>

        <PersonalFormulasSection rating={reviewData?.[0]?.trim() || '4.88'} />
        <MillionCombinations slug={slug} dark />

        <section className="steps section-padding video-bg d-flex align-items-center justify-content-center t-h-[400px] lg:t-h-[600px]">
          <div
            dangerouslySetInnerHTML={{
              __html: `<video className="sm:!t-hidden" autoplay loop muted playsinline>
                      <source
                          src=${NoMorePillsVideo}
                          data-src="assets/riise-people-sport-energy-granules.mp4"
                          type="video/mp4"
                      />
                      Your browser does not support the video tag.
                    </video>`,
            }}
          />
          <div className="container">
            <div className="row gy-4">
              <div className="col-lg-12 text-center !t-max-w-[500px] t-mx-auto"></div>
            </div>
          </div>
        </section>

        {/* <div className="t-flex t-items-center t-justify-center t-mt-2">
          <MakeChoice />
        </div> */}
        <div className="t-flex t-items-center t-justify-center t-bg-g100">
          <Partners />
        </div>

        <section className="t-py-6 md:t-py-8 t-px-8">
          <h2 className="t-text-[24px] md:t-text-[30px] t-text-center t-font-serif t-font-normal t-mb-8 t-text-navy">
            {t(WhatAreYourWellnessGoals)}
          </h2>
          <div className="container !t-px-0 t-flex t-flex-row t-gap-2 md:t-gap-4 t-overflow-auto hide-scrollbar ">
            {filteredFocusAreas?.map((item, index) => {
              const focusIcon = findAssetByCodeOrName(focusAreaIcons?.data, item);
              const displayName = getAssetDisplayName(item);
              return (
                <CustomLink
                  to={FOCUS_AREA_LINKS[item.code] || FOCUS_AREA_LINKS[item.name]}
                  className={`t-relative t-flex-none t-w-[200px] t-h-[200px] t-flex !i-items-start !t-py-4 t-gap-2 t-rounded-[0.2rem] t-px-2 t-ml-0 t-mr-2 `}
                  style={{
                    backgroundImage: `linear-gradient(180deg, rgba(29, 29, 31, 0.10) 0%, rgba(29, 29, 31, 0.75) 100%), url(${
                      process.env.REACT_APP_PUBLIC_URL
                    }${item?.url.replace('focusareas', 'focusarea')})`,
                    backgroundSize: 'cover',
                  }}
                  key={'focus-areas-home-' + index}
                >
                  <img
                    src={`${process.env.REACT_APP_PUBLIC_URL}${focusIcon?.url}`}
                    alt=""
                    className="t-w-5 t-h-5 t-mb-[-2px] t-mt-auto"
                  />
                  <p className="t-text-white t-font-sans t-font-semibold t-text-[15px] t-leading-4 t-m-0 t-mt-auto">
                    {displayName}
                  </p>
                </CustomLink>
              );
            })}
          </div>
        </section>

        <section className="faq t-pt-2 t-pb-3 md:t-pb-6">
          <div className="container-fluid text-center px-0 ">
            <div className="row gx-0 !t-max-w-[1330px] !t-mx-auto">
              <h3 className="t-text-[24px] md:t-text-[30px] !t-text-center t-font-serif t-font-normal t-text-navy">
                {t(Faq)}
              </h3>
              <div className="col-lg-12 align-items-center d-flex faq-home">
                <EffectAccordion data={data} />
              </div>
              <p className="!t-text-center t-font-sans t-mx-auto t-text-navy/70 t-text-base t-mt-4">
                {t(FaqMore)}{' '}
                <span>
                  <CustomLink to="/faqs" className="t-underline t-text-navy">
                    {t(FaqPage)}
                  </CustomLink>
                </span>
              </p>
            </div>
          </div>
        </section>

        <section className="t-pt-0 t-pb-10 md:t-pb-6 t-max-w-[700px] t-mx-auto t-bg-white t-px-4 t-flex t-flex-col t-gap-6">
          <h3 className="t-text-[24px] md:t-text-[30px] !t-text-center t-font-serif t-font-normal t-text-navy">
            {t(HereMainHeading)}
          </h3>

          <HereForYou />
        </section>
      </main>
      <a
        href="https://wa.me/+4915156047816"
        target="_blank"
        rel="noreferrer"
        className={`t-fixed t-bottom-24 sm:t-bottom-5 t-right-7 t-z-50 t-bg-white t-rounded-full t-shadow-md t-transition-opacity t-duration-300 ${scrolledPastHero ? 't-opacity-100' : 't-opacity-0 t-pointer-events-none'}`}
        onClick={() => metaEvent('Contact')}
      >
        <img src={Whatsapp} alt="" className="t-h-10 t-w-10 md:t-h-15 md:t-w-15" />
      </a>
    </>
  );
};

export default Home;
